import {styled, Theme} from "@mui/material/styles";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Link from "@mui/material/Link";


export const Form = styled('form')(({ theme }) => ({
    width: "100%",
    '& .MuiFormControl-root': {
        width: "100%",
        marginTop: theme.spacing(.75),
        marginBottom: 0,
    }
}));

export interface ButtonBarProps {
    buttonAlignment: | "alignLeft" | "alignRight";
};

export interface DaButtonProps {
    buttonStyle: | "primary" | "secondary";
};

export const ButtonBar = styled(Box, {
    shouldForwardProp: (props) => props !== 'buttonAlignment',
})<ButtonBarProps>(({ theme, buttonAlignment}) => ({
    display: "flex",
    alignItems: "center",
    marginTop: theme.spacing(1),
    ...(buttonAlignment === "alignLeft") && {
        justifyContent: "start",
        '& .MuiButton-root': {
            marginRight: theme.spacing(1),
        }
    },
    ...(buttonAlignment === "alignRight") && {
        justifyContent: "end",
        '& .MuiButton-root': {
            marginLeft: theme.spacing(1),
        }
    }
}));

export const DaButton = styled(Button, {
    shouldForwardProp: (props) => props !== 'buttonStyle',
})<DaButtonProps>(({ theme, buttonStyle }) => ({
    borderWidth: "1px",
    borderStyle:"solid",
    paddingTop: theme.spacing(.75),
    paddingRight: theme.spacing(2),
    paddingBottom: theme.spacing(.75),
    paddingLeft: theme.spacing(2),
    ...(buttonStyle === "primary") && {
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.primary.main,
        borderColor: theme.palette.primary.main,
        '&:hover': {
            backgroundColor: theme.palette.primary.dark,
            borderColor: theme.palette.primary.dark,
        }
    },
    ...(buttonStyle === "secondary") && {
        color: theme.daPalette.grey.dark,
        backgroundColor: theme.palette.background.default,
        borderColor: theme.daPalette.grey.main,
        '&:hover': {
            backgroundColor: theme.daPalette.lightGrey.main,
            borderColor: theme.daPalette.grey.dark,
        }
    }
}));

export const SecondaryButton = styled(Button)(({ theme }) => ({
    // width: theme.spacing(12),
    color: theme.daPalette.grey.dark,
    backgroundColor: theme.palette.background.default,
    borderColor: theme.daPalette.grey.main,
    borderWidth: "1px",
    borderStyle:"solid",
    paddingTop: theme.spacing(.75),
    paddingRight: theme.spacing(2),
    paddingBottom: theme.spacing(.75),
    paddingLeft: theme.spacing(2),
    '&:hover': {
        borderColor: theme.daPalette.grey.dark,
        backgroundColor: theme.daPalette.lightGrey.main,
    }
}));

export const PrimaryButton = styled(Button)(({ theme }) => ({
    // width: theme.spacing(18),
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.primary.main,
    borderColor: theme.palette.primary.main,
    borderWidth: "1px",
    borderStyle:"solid",
    paddingTop: theme.spacing(.75),
    paddingRight: theme.spacing(2),
    paddingBottom: theme.spacing(.75),
    paddingLeft: theme.spacing(2),
    '&:hover': {
        backgroundColor: theme.palette.primary.dark,
        borderColor: theme.palette.primary.dark,
    }
}));

export const ShowMoreLink = styled(Link)(({ theme }) => ({
    color: theme.daPalette.orange.main,
    textDecorationColor: theme.daPalette.orange.main,
}));

